import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {

  constructor(
    private _message: MessageService
  ) {

  }

  ngOnInit(): void {
    this._message.emitChange("NAV", "SECTION", {
      path: "integrations/website"
    });
  }
}
